import { lectureDuResultat, texteDuResultat, ETAT_PAS_ENCORE_VALIDE, ETAT_SANS_SCORE } from "./FormatFinDeModule"

/* ⛔ « MON RÉSULTAT » LIT LA SLIDE FIN DE MODULE (07/10/2026, demande de Nawal).
   La fenetre « Mon résultat » du tableau de bord prenait son texte dans les
   paliers des slides Diagnostic (`seuils` de la ligne du plan). Un module qui
   se termine par une slide Fin de module doit y montrer la MEME chose que la
   slide : son score (glbMaster) et le texte que Nawal a ecrit pour le cas
   « validé » ou « pas encore validé ». Le design de la fenetre ne change pas :
   ni rosette ni libelle, le bouton certificat reste ou il est.

   LA DONNEE : le serveur envoie, pour chaque module termine du plan,
   `finDeModule` = le champ `answers` de sa slide Fin de module (objet ou JSON
   texte : { textes: { valide, pasEncoreValide }, titreResultat }). Demande a
   Hicham le 07/10/2026 : `getAllInfos` ne remontait que les slides Diagnostic
   (models/content.js, getSeqsCatsByContentIdAsync, `type = "Diagnostic"`).
   Tant que `finDeModule` n'arrive pas, la fenetre garde l'ancienne lecture.

   LES REGLES sont celles de la slide, importees et jamais recopiees : score
   et etat par `lectureDuResultat` (valide a partir de 50, comme le
   certificat), texte par `texteDuResultat` ; « pas encore validé » sans texte :
   l'annonce du rattrapage (`defautPasEncore`, tu ou vous selon la cible du
   module) ; pas de score de module : pas de texte. */

/* 08/10/2026 (reponse d'Hicham : « plan[i].finDeModule portera les textes de
   la derniere slide Fin de module ») : la forme exacte n'est pas encore lisible.
   On accepte donc les deux : le champ `answers` entier ({ textes: { valide,
   pasEncoreValide } }) ou les textes seuls ({ valide, pasEncoreValide }). */
export const lireFinDeModule = (module) => {
  let f = module?.finDeModule
  if (typeof f === "string") {
    try { f = JSON.parse(f) } catch (e) { return null }
  }
  if (!f || typeof f !== "object" || Array.isArray(f)) return null
  if (f.textes && typeof f.textes === "object") return f
  if (typeof f.valide === "string" || typeof f.pasEncoreValide === "string") {
    return { ...f, textes: { valide: f.valide, pasEncoreValide: f.pasEncoreValide } }
  }
  return f
}

/* { score, texte } pour « Mon résultat », ou null si le module n'a pas de
   slide Fin de module (la fenetre garde alors sa lecture des Diagnostics). */
export const resultatPourMonResultat = (module, defautPasEncore) => {
  const fin = lireFinDeModule(module)
  if (!fin) return null
  const { etat, score } = lectureDuResultat(module?.resultFin)
  const ecrit = etat === ETAT_SANS_SCORE ? "" : texteDuResultat(fin, etat).trim()
  const texte = ecrit !== "" ? ecrit : (etat === ETAT_PAS_ENCORE_VALIDE ? (defautPasEncore || "") : "")
  return { score, texte }
}
